export const dict: Record<string, string> = {
  "ui.sessionReview.title": "Session changes",
  "ui.sessionReview.title.git": "Git changes",
  "ui.sessionReview.title.branch": "Branch changes",
  "ui.sessionReview.title.lastTurn": "Last turn changes",
  "ui.sessionReview.diffStyle.unified": "Unified",
  "ui.sessionReview.diffStyle.split": "Split",
  "ui.sessionReview.expandAll": "Expand all",
  "ui.sessionReview.collapseAll": "Collapse all",
  "ui.sessionReview.change.added": "Added",
  "ui.sessionReview.change.removed": "Removed",
  "ui.sessionReview.change.modified": "Modified",
  "ui.sessionReview.image.loading": "Loading...",
  "ui.sessionReview.image.placeholder": "Image",
  "ui.sessionReview.largeDiff.title": "Diff too large to render",
  "ui.sessionReview.largeDiff.meta": "Limit: {{limit}} changed lines. Current: {{current}} changed lines.",
  "ui.sessionReview.largeDiff.renderAnyway": "Render anyway",
  "ui.sessionReview.openFile": "Open file",
  "ui.sessionReview.selection.line": "line {{line}}",
  "ui.sessionReview.selection.lines": "lines {{start}}-{{end}}",

  "ui.fileMedia.kind.image": "image",
  "ui.fileMedia.kind.audio": "audio",
  "ui.fileMedia.state.removed": "Removed {{kind}} file.",
  "ui.fileMedia.state.loading": "Loading {{kind}}...",
  "ui.fileMedia.state.error": "Unable to load {{kind}}.",
  "ui.fileMedia.state.unavailable": "{{kind}} preview unavailable.",
  "ui.fileMedia.binary.title": "Binary file",
  "ui.fileMedia.binary.description.path": "{{path}} is binary.",
  "ui.fileMedia.binary.description.default": "Binary content",

  "ui.lineComment.label.prefix": "Comment on ",
  "ui.lineComment.label.suffix": "",
  "ui.lineComment.editorLabel.prefix": "Commenting on ",
  "ui.lineComment.editorLabel.suffix": "",
  "ui.lineComment.placeholder": "Add comment",
  "ui.lineComment.submit": "Comment",

  "ui.sessionTurn.steps.show": "Show steps",
  "ui.sessionTurn.steps.hide": "Hide steps",
  "ui.sessionTurn.summary.response": "Response",
  "ui.sessionTurn.diff.showMore": "Show more changes ({{count}})",
  "ui.sessionTurn.diffs.changed": "Changed",
  "ui.sessionTurn.diffs.showAll": "Show all",
  "ui.sessionTurn.diffs.showLess": "Show less",
  "ui.sessionTurn.diffs.more": "+{{count}} more files",

  "ui.sessionTurn.retry.retrying": "retrying",
  "ui.sessionTurn.retry.inSeconds": "in {{seconds}}s",
  "ui.sessionTurn.retry.attempt": "attempt #{{attempt}}",
  "ui.sessionTurn.retry.attemptLine": "{{line}} - attempt #{{attempt}}",
  "ui.sessionTurn.retry.geminiHot": "gemini is way too hot right now",
  "ui.sessionTurn.error.retry": "Retry",
  "ui.sessionTurn.error.fallback": "The request failed ({{name}}). Press «Retry» to run it again.",
  "ui.sessionTurn.emptyAnswer": "The model returned an empty response. Try sending the request again.",
  "ui.sessionTurn.error.freeUsageExceeded": "Free usage exceeded",
  "ui.sessionTurn.error.addCredits": "Add credits",
  "ui.sessionTurn.error.codexModelNotSupported":
    "The {{model}} model is not available for your ChatGPT account. Pick another model, or connect OpenAI with an API key. If this model worked before, check that your ChatGPT subscription is still active.",
  "ui.sessionTurn.error.databaseDamaged":
    "The chat database on this computer is damaged, so the request failed before reaching any model — switching models will not help. Restart MultiTool: on launch it checks the database and restores the latest backup, keeping the damaged file beside it.",
  "ui.sessionTurn.error.brokenToolHistory":
    "The turn broke off before a tool finished, so this chat's history is incomplete and the model refuses to read it. Press «Retry» — the gap is repaired automatically. If it repeats, the connection is dropping mid-turn.",
  "ui.sessionTurn.error.upstreamKeyRefused":
    "The provider rejected the API key ****{{suffix}}. If this machine has its own key set (an environment variable such as DEEPSEEK_API_KEY), it overrides the built-in access. Settings → Models → «Access source» shows which key is in use and lets you switch back.",
  "ui.sessionTurn.error.modelNotFound":
    "«{{provider}}» says it has no model {{model}} at the address it was asked. That usually means the model id or the server address is wrong: Settings → Models → «{{provider}}». Check the id matches the provider's own documentation, and that the model is served at that address.",
  "ui.sessionTurn.error.brokeredBalance":
    "{{provider}} is temporarily unavailable on our side: the provider refused the request over OUR account, not yours — there is nothing for you to pay. Try again in a few minutes or pick another model (GigaChat works independently), and tell us via «Send feedback» if it keeps happening.",
  "ui.sessionTurn.error.modelNotFoundBrokered":
    "{{provider}} says it has no model {{model}}. That is nothing you configured — try again or pick another model, and tell us if it keeps happening.",
  "ui.sessionTurn.error.dailyBudgetExceeded":
    "Today's usage limit for this install has been reached. It resets at {{time}} — until then, try a GigaChat or local model. Details: Settings → Diagnostics.",
  "ui.sessionTurn.error.dailyBudgetExceededNoTime":
    "Today's usage limit for this install has been reached. It resets at midnight UTC — until then, try a GigaChat or local model. Details: Settings → Diagnostics.",
  "ui.sessionTurn.error.providerInit.credentials":
    "No access to {{provider}} yet: the app is still getting its access key. Wait a minute or restart the app, then press «Retry».",
  "ui.sessionTurn.error.providerInit.tls":
    "{{provider}} could not be started: this computer does not trust the certificate of its server. Settings → Diagnostics shows what is missing.",
  "ui.sessionTurn.error.providerInit.network":
    "{{provider}} could not be started: what it needs could not be downloaded. Check the internet connection or the proxy settings, then press «Retry».",
  "ui.sessionTurn.error.providerInit.other":
    "{{provider}} could not be started, so the request was not sent. Restart the app; if it keeps happening, tell us via «Send feedback».",
  "ui.sessionTurn.error.switchToGigaChat": "Switch to GigaChat",
  "ui.sessionTurn.error.sendAtReset": "Send when the limit resets (at {{time}})",
  "ui.sessionTurn.error.sendAtResetNoTime": "Send when the limit resets",
  "ui.sessionTurn.error.sessionTooLarge":
    "This chat has grown too large for the model to process, even after compacting it, so retrying will not help. Start a new chat to continue.",
  "ui.sessionTurn.error.startNewChat": "Start a new chat",

  "ui.sessionTurn.status.delegating": "Delegating work",
  "ui.sessionTurn.status.planning": "Planning next steps",
  "ui.sessionTurn.status.gatheringContext": "Exploring",
  "ui.sessionTurn.status.gatheredContext": "Explored",
  "ui.sessionTurn.status.searchingCodebase": "Searching the codebase",
  "ui.sessionTurn.status.searchingWeb": "Searching the web",
  "ui.sessionTurn.status.makingEdits": "Making edits",
  "ui.sessionTurn.status.runningCommands": "Running commands",
  "ui.sessionTurn.status.working": "Working",
  "ui.sessionTurn.phase.waiting": "Waiting for the model",
  "ui.sessionTurn.phase.connecting": "Connecting to the server",
  "ui.sessionTurn.phase.reconnecting": "Reconnecting to the server",
  "ui.sessionTurn.connection.attempt": "attempt {{attempt}}",
  "ui.sessionTurn.connection.slow":
    "The server is slow to answer. If this keeps happening, check your VPN, proxy or antivirus.",
  "ui.sessionTurn.phase.thinking": "Thinking",
  "ui.sessionTurn.phase.responding": "Writing the answer",
  "ui.sessionTurn.phase.preparing": "Preparing an action",
  "ui.toolActivity.unit.kb": "KB",
  "ui.toolActivity.unit.b": "B",
  "ui.toolActivity.slides": "building a presentation · slide {{count}}",
  "ui.toolActivity.sheets": "building a spreadsheet · sheet {{count}}",
  "ui.toolActivity.sheetsRows": "building a spreadsheet · sheet {{count}}, {{rows}} rows",
  "ui.toolActivity.paragraphs": "building a document · {{count}} paragraphs",
  "ui.toolActivity.writingFile": "writing {{target}}",
  "ui.toolActivity.writingUnnamed": "writing a file",
  "ui.toolActivity.preparingTarget": "preparing: {{target}}",
  "ui.toolActivity.runningTarget": "running: {{target}}",
  "ui.toolActivity.runningSkill": "loading skill: {{target}}",
  "ui.toolActivity.runningTask": "sub-agent working: {{target}}",
  "ui.sessionTurn.phase.tool": "Running an action",
  "ui.sessionTurn.phase.quiet": "No new events for {{seconds}}s",
  "ui.sessionTurn.phase.quietHelp": "Time since the app received a change to the response or action. This alone does not mean the task is stuck.",
  "ui.sessionTurn.status.completed": "Done",
  "ui.sessionTurn.verification.passed": "Verified",
  "ui.sessionTurn.verification.failed": "Verification failed",
  "ui.sessionTurn.verification.unverified": "Not verified",
  "ui.sessionTurn.verification.not_required": "Verification not required",
  "ui.sessionTurn.verification.checks.one": "{{count}} check",
  "ui.sessionTurn.verification.checks.other": "{{count}} checks",
  "ui.sessionTurn.verification.details.show": "Show verification details",
  "ui.sessionTurn.verification.details.hide": "Hide verification details",
  "ui.sessionTurn.verification.exitCode": "Exit code: {{code}}",
  "ui.sessionTurn.verification.noChecks": "Files changed, but no verification command was recorded.",
  "ui.sessionTurn.verification.attempts.one": "{{count}} automatic attempt",
  "ui.sessionTurn.verification.attempts.other": "{{count}} automatic attempts",
  "ui.sessionTurn.verification.requirement.missing": "Missing required check",
  "ui.sessionTurn.verification.requirement.optional": "Optional",
  "ui.sessionTurn.verification.review.passed": "Semantic review passed",
  "ui.sessionTurn.verification.review.failed": "Semantic review found issues",
  "ui.sessionTurn.verification.review.error": "Semantic review could not run",
  "ui.sessionTurn.verification.review.not_run": "Semantic review not run",
  "ui.sessionTurn.status.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingWithTopic": "Thinking - {{topic}}",
  "ui.sessionTurn.status.thinkingPhrase.whirring": "Whirring",
  "ui.sessionTurn.status.thinkingPhrase.boondoggling": "Boondoggling",
  "ui.sessionTurn.status.thinkingPhrase.flummoxing": "Flummoxing",
  "ui.sessionTurn.status.thinkingPhrase.cooking": "Cooking",
  "ui.sessionTurn.status.thinkingPhrase.crafting": "Crafting",
  "ui.sessionTurn.status.thinkingPhrase.pondering": "Pondering",
  "ui.sessionTurn.status.thinkingPhrase.thinking": "Thinking",
  "ui.sessionTurn.status.thinkingPhrase.processing": "Processing",
  "ui.sessionTurn.status.gatheringThoughts": "Gathering thoughts",
  "ui.sessionTurn.status.consideringNextSteps": "Considering next steps",

  "ui.messagePart.diagnostic.error": "Error",
  "ui.messagePart.title.edit": "Editing",
  "ui.messagePart.title.edit.completed": "Edit completed",
  "ui.messagePart.title.write": "Writing",
  "ui.messagePart.title.write.completed": "Write completed",
  "ui.messagePart.option.typeOwnAnswer": "Type your own answer",
  "ui.messagePart.review.title": "Review your answers",
  "ui.messagePart.questions.dismissed": "Questions dismissed",
  "ui.messagePart.compaction": "Session compacted",
  "ui.messagePart.context.read.one": "{{count}} read",
  "ui.messagePart.context.read.other": "{{count}} reads",
  "ui.messagePart.context.search.one": "{{count}} search",
  "ui.messagePart.context.search.other": "{{count}} searches",
  "ui.messagePart.context.list.one": "{{count}} list",
  "ui.messagePart.context.list.other": "{{count}} lists",

  "ui.list.loading": "Loading",
  "ui.list.empty": "No results",
  "ui.list.clearFilter": "Clear filter",
  "ui.list.emptyWithFilter.prefix": "No results for",
  "ui.list.emptyWithFilter.suffix": "",

  "ui.fileSearch.placeholder": "Find",
  "ui.fileSearch.previousMatch": "Previous match",
  "ui.fileSearch.nextMatch": "Next match",
  "ui.fileSearch.close": "Close search",

  "ui.messageNav.newMessage": "New message",

  "ui.textField.copyToClipboard": "Copy to clipboard",
  "ui.textField.copyLink": "Copy link",
  "ui.textField.copied": "Copied",

  "ui.imagePreview.alt": "Image preview",
  "ui.scrollView.ariaLabel": "scrollable content",

  "ui.tool.read": "Read",
  "ui.tool.loaded": "Read",
  "ui.tool.list": "List",
  "ui.tool.memory": "Memory",
  "ui.tool.memory.remembered": "Remembered",
  "ui.tool.memory.undo": "Undo",
  "ui.tool.memory.undone": "Removed from memory",
  "ui.tool.autoApproved": "approved automatically",
  "ui.tool.autoApproved.detail": "Judged read-only by the classifier ({{backend}}, p = {{p}}) and run without asking",
  "ui.tool.autoApproved.disable": "Turn off",
  "ui.tool.autoApproved.off": "auto-approval turned off",
  "ui.tool.glob": "Finding files",
  "ui.tool.grep": "Searching in file",
  "ui.tool.search.completed": "Search completed",
  "ui.tool.task": "Task",
  "ui.tool.task.completed": "Task completed",
  "ui.taskFleet.agents": "{{count}} agents",
  "ui.taskFleet.tokens": "{{count}} tokens",
  "ui.taskFleet.background": "background",
  "ui.tool.webfetch": "Webfetch",
  "ui.tool.webfetch.completed": "Fetch completed",
  "ui.tool.websearch": "Web Search",
  "ui.tool.shell": "Shell",
  "ui.tool.shell.completed": "Command completed",
  "ui.tool.patch": "Patch",
  "ui.tool.patch.completed": "Patch completed",
  "ui.tool.todos": "To-dos",
  "ui.tool.todos.read": "Read to-dos",
  "ui.tool.questions": "Questions",
  "ui.tool.questions.answered": "Questions answered",
  "ui.tool.agent": "{{type}} Agent",
  "ui.tool.agent.default": "Agent",
  "ui.tool.error.title": "{{tool}} error",
  "ui.tool.outcome.rejected.title": "Rejected by you",
  "ui.tool.outcome.rejected.command": "You rejected the command",
  "ui.tool.outcome.rejected.action": "You rejected the action",
  "ui.tool.outcome.rejected.feedback": "Your comment: {{feedback}}",
  "ui.tool.outcome.stopped.title": "Stopped",
  "ui.tool.outcome.stopped.body": "The run was stopped before it finished",
  "ui.tool.outcome.cut.body": "Not finished: you rejected another action, which ended the turn",
  "ui.tool.skill": "Skill",
  "ui.tool.reportFindings": "Code review",
  "ui.tool.reportFindings.title": "Code review",
  "ui.tool.reportFindings.pending": "Reviewing changes",
  "ui.tool.reportFindings.count": "{{count}} findings",
  "ui.tool.reportFindings.empty": "No findings — nothing survived verification.",
  "ui.tool.reportFindings.dropped": "{{count}} more were dropped: the report exceeded the cap.",
  "ui.tool.reportFindings.unknownFile": "Unknown file",
  "ui.tool.reportFindings.verdict.confirmed": "Confirmed",
  "ui.tool.reportFindings.verdict.plausible": "Plausible",
  "ui.tool.reportFindings.outcome.fixed": "Fixed",
  "ui.tool.reportFindings.outcome.skipped": "Skipped",
  "ui.tool.reportFindings.outcome.noChange": "No change needed",
  "ui.tool.reportFindings.action.open": "Show in code",
  "ui.tool.reportFindings.action.fixOne": "Fix",
  "ui.tool.reportFindings.action.fixAll": "Fix all",
  "ui.tool.skill.error": "Skill error",
  "ui.tool.skill.loading": "Loading skill {{skill}}",
  "ui.tool.skill.preparing": "Preparing skill {{skill}}",
  "ui.tool.skill.using": "Using skill {{skill}}",
  "ui.tool.skill.used": "Used skill {{skill}}",
  "ui.tool.details.element": "Element",
  "ui.tool.details.path": "Path",
  "ui.tool.details.pattern": "Pattern",
  "ui.tool.details.include": "Include",
  "ui.tool.details.query": "Query",
  "ui.tool.details.url": "URL",
  "ui.tool.details.agent": "Agent",
  "ui.tool.details.task": "Task",
  "ui.tool.details.session": "Session",
  "ui.tool.details.description": "Description",

  "ui.basicTool.called": "Called `{{tool}}`",
  "ui.toolErrorCard.failed": "Failed",
  "ui.toolErrorCard.copyError": "Copy error",

  "ui.common.file.one": "file",
  "ui.common.file.other": "files",
  "ui.common.question.one": "question",
  "ui.common.question.other": "questions",

  "ui.common.add": "Add",
  "ui.common.back": "Back",
  "ui.common.cancel": "Cancel",
  "ui.common.confirm": "Confirm",
  "ui.common.dismiss": "Dismiss",
  "ui.toast.copy": "Copy",
  "ui.toast.logs": "Log",
  "ui.common.close": "Close",
  "ui.common.download": "Download",
  "ui.common.next": "Next",
  "ui.common.submit": "Submit",

  "ui.permission.deny": "Deny",
  "ui.permission.allowAlways": "Allow always",
  "ui.permission.allowOnce": "Allow once",

  "ui.message.expand": "Expand message",
  "ui.message.collapse": "Collapse message",
  "ui.message.copy": "Copy",
  "ui.message.copyMessage": "Copy message",
  "ui.message.forkMessage": "Fork to new session",
  "ui.message.revertMessage": "Revert message",
  "ui.message.copyResponse": "Copy response",
  "ui.message.copied": "Copied",
  "ui.message.chatLink": "Chat",
  "ui.markdown.plain.notice": "Long text is shown without formatting.",
  "ui.markdown.plain.format": "Show formatted",
  "ui.message.duration.seconds": "{{count}}s",
  "ui.message.duration.minutesSeconds": "{{minutes}}m {{seconds}}s",
  "ui.message.duration.hoursMinutes": "{{hours}}h {{minutes}}m",
  "ui.message.interrupted": "Interrupted",
  "ui.message.interruptedAppClosed": "Interrupted: the app was closed",
  "ui.message.queued": "Queued",
  "ui.message.attachment.alt": "attachment",
  "ui.message.attachment.notPublished": "attachment not published — files stay on the author's computer",

  "ui.patch.action.deleted": "Deleted",
  "ui.patch.action.created": "Created",
  "ui.patch.action.moved": "Moved",
  "ui.patch.action.patched": "Patched",

  "ui.question.subtitle.answered": "{{count}} answered",
  "ui.question.answer.none": "(no answer)",
  "ui.question.review.notAnswered": "(not answered)",
  "ui.question.multiHint": "Select all answers that apply",
  "ui.question.singleHint": "Select one answer",
  "ui.question.custom.placeholder": "Type your answer...",
  "ui.question.async.hint": "You can answer later — the work continues",
  "ui.question.async.more": "{{count}} more waiting",
  "ui.question.async.waiting": "Waiting for an answer while the work continues",
  "ui.question.async.answerSent": "Answer sent",
}
